import { useState } from 'react'

/**
 * Hook to manage form submission state consistently across all forms.
 * Consolidates loading, submission, and success/failure state management.
 */
export const useFormSubmissionState = () => {
  const [loading, setLoading] = useState(false)
  const [formSubmit, setFormSubmit] = useState(false)
  const [formSubmitSuccess, setFormSubmitSuccess] = useState(false)

  /**
   * Call when starting form submission.
   * Sets loading to true.
   */
  const startSubmission = () => {
    setLoading(true)
  }

  /**
   * Call when form submission completes (success or failure).
   * Sets formSubmit to true, loading to false, and formSubmitSuccess to the provided value.
   * @param success - Whether the submission was successful
   */
  const finishSubmission = (success: boolean) => {
    setFormSubmit(true)
    setFormSubmitSuccess(success)
    setLoading(false)
  }

  /**
   * Reset all form submission state to initial values.
   */
  const reset = () => {
    setLoading(false)
    setFormSubmit(false)
    setFormSubmitSuccess(false)
  }

  return {
    loading,
    formSubmit,
    formSubmitSuccess,
    startSubmission,
    finishSubmission,
    reset,
  }
}
